import { createSiteConfig } from '@alascorporation/seo'

export const siteConfig = createSiteConfig({
  type: 'lms',
  name: 'Academy by ALAS',
  brandName: 'Academy',
  url: (typeof import.meta !== 'undefined' && (import.meta as { env?: { VITE_BASE_URL?: string } }).env?.VITE_BASE_URL) || 'https://academy.satelab.org',
  defaultTitle: 'Academy by ALAS | Aprende Cohetería, Satélites y Aeroespacial',
  titleTemplate: '%s | Academy by ALAS',
  defaultDescription:
    'Plataforma de aprendizaje STEM aeroespacial. Cursos de cohetería, construcción de satélites, aviación y exploración espacial. Aprende a tu ritmo con instructores certificados por ALAS Corporation.',
  defaultImage: '/og-academy.jpg',
  locale: 'es_CO',
  language: 'es',
  themeColor: '#0a0a0a',
  organization: {
    legalName: 'ALAS Corporation',
    alternateName: ['SateLab Academy', 'ALAS Academy'],
    logo: '/logo.svg',
    address: { city: 'Medellín', region: 'Antioquia', country: 'CO' },
    contact: { email: 'academy@satelab.org' },
    socials: [
      'https://www.instagram.com/corp_alas',
      'https://www.facebook.com/corp.alas',
      'https://www.linkedin.com/company/alas-corp/',
    ],
    knowsAbout: [
      'Educación STEM',
      'Cohetería educativa',
      'Modelismo espacial',
      'Aviación educativa',
      'Tecnología aeroespacial',
      'Satélites educativos',
      'CanSat',
      'Cursos online aeroespacial',
      'LMS STEM Colombia',
    ],
  },
  analytics: {
    ga4: (typeof import.meta !== 'undefined' && (import.meta as { env?: { VITE_GA4_ID?: string } }).env?.VITE_GA4_ID) || undefined,
    facebookPixel: (typeof import.meta !== 'undefined' && (import.meta as { env?: { VITE_FB_PIXEL_ID?: string } }).env?.VITE_FB_PIXEL_ID) || undefined,
    crossDomains: ['satelab.org', 'cccd.space'],
  },
  searchEnabled: true,
})
